import { IssuerService, LoginResponse, SSO } from "./IssuerService";
import { ParsedQuery } from "query-string";
import { LoggerFactory, RemoteApi } from "lego-gui-lib";
import { RedirectState } from "./auth";
import { getBaseUrl, getCookie } from "../../common/common";
import { mainStore } from "../mainStore";

const log = LoggerFactory.create("InternalSSOService");

export class InternalSSOService implements IssuerService {
  public issuer = "InternalSSO";

  private remoteApi: RemoteApi;

  public constructor(api: RemoteApi) {
    this.remoteApi = api;
  }

  public async login(
    params: ParsedQuery,
    redirectState: RedirectState
  ): Promise<LoginResponse> {
    const issuer = redirectState.issuer;
    const accessCode = getCookie(mainStore.auth.getCookieName());
    const redirectUrl = params.url as string;

    const response = await this.remoteApi.postMethod<any>(
      "/public/auth/login",
      {
        accessCode: accessCode,
        redirectUri: window.location.href,
        issuer: issuer
      }
    );

    return Promise.resolve({ redirectUrl: redirectUrl, csrf: response.csrf });
  }

  public async redirect(sso: SSO): Promise<void> {
    const baseUrl = getBaseUrl();
    const primaryRedirect = encodeURIComponent(`${baseUrl}/loginRedirect`);
    const failureRedirect = encodeURIComponent(`${baseUrl}/loginFailed`);
    const loginRedirect = `${sso.url}${sso.loginPath}?gotoOnFail=${failureRedirect}&goto=${primaryRedirect}`;
    log.debug("redirecting to", loginRedirect);
    window.location.href = loginRedirect;
  }

  public async logoutRedirect(sso: SSO): Promise<void> {
    const loginRedirect = `${sso.url}${sso.logoutPath}`;
    log.debug("redirecting to", loginRedirect);
    window.location.href = loginRedirect;
  }
}
